<template>
  <v-col cols="6">
      <v-card
        class="mx-auto"
        color="grey lighten-4"
        max-width="400"
      >

      <v-carousel
      v-if="rolling"
      :show-arrows="false"
      hide-delimiters
      cycle
      interval="100"
      touchless
      continuous
      height="25vh"
      >
      <v-carousel-item
      v-for="(image,i) in images"
      :key="i"
      :src="image"
      max-height="25vh"
          ></v-carousel-item>
        </v-carousel>

        <v-img
          v-if="rolled"
         :src="rolledImage"
         max-height="25vh"
        ></v-img>

        <v-img
        v-if="!rolled && !rolling"
       src="https://i.imgur.com/C1UZdQi.png"
       max-height="25vh"
      ></v-img>

        <v-card-text
          class="pt-6"
          style="position: relative;"
        >
          <p class="subtitle-1 font-weight-light black--text mb-2">{{rolledTitle}}</p>
        </v-card-text>
    </v-card>
  </v-col>
</template>

  <script>
      export default {
        name: 'RouletteCard',
        props: {
          rollTitle: String,
          titles: Array,
          images: Array,
          rolled: Boolean
        },
        data: function () {
          return {
            rolledTitle: '',
            rolledImage: '',
            rolling: false
          }
        },
        methods:{

        },
        watch: {
          rolled: {
            immediate: true, 
            handler (val, oldVal) {
              this.rolledTitle = this.rollTitle;
              if(val){
                this.rolling = true;
                console.log("Running initial roll animation");
                setTimeout(()=>{
                  console.log("Time up");
                  this.rolling = false;
                  this.rolled = val;
                  let randomIndex = Math.floor(Math.random() * this.images.length);
                  this.rolledTitle = this.titles[randomIndex]
                  this.rolledImage = this.images[randomIndex]
                }, 3000);
              }
            }
          },

        }
      }
  </script>